import React, { type Dispatch, type SetStateAction } from 'react';

import { AppleLoginButton } from '@/app/[locale]/(auth)/components/AppleLoginButton';
import { EbayLoginButton } from '@/app/[locale]/(auth)/components/EbayLoginButton';
import { GoogleLoginButton } from '@/app/[locale]/(auth)/components/GoogleLoginButton';
import { ON_IDENTIFIER } from '@/modules/experiments/config';
import { useExperiments } from '@/modules/experiments/useExperiments';

export type SocialLoginProps = {
  nonce: string;
  handleError: Dispatch<SetStateAction<string>>;
  setIsAccountLinkingError: Dispatch<SetStateAction<boolean>>;
};

export function SocialLogin({
  nonce,
  handleError,
  setIsAccountLinkingError,
}: SocialLoginProps) {
  const { web_9278_ebay_sso } = useExperiments(['web_9278_ebay_sso']);
  const isEbaySSOEnabled = web_9278_ebay_sso === ON_IDENTIFIER;

  return (
    <>
      <GoogleLoginButton
        nonce={nonce}
        setError={handleError}
        setIsAccountLinkingError={setIsAccountLinkingError}
      />
      <AppleLoginButton
        setError={handleError}
        setIsAccountLinkingError={setIsAccountLinkingError}
      />
      {isEbaySSOEnabled && (
        <EbayLoginButton
          setError={handleError}
          setIsAccountLinkingError={setIsAccountLinkingError}
        />
      )}
    </>
  );
}
